import googleAnalytics from 'lib/GoogleAnalytics';
import eventLogger from 'lib/EventLogger';
import { EventType, Features, SourcePages } from 'lib/EventSchema';

function logGAFavoritesInteractionEvent(action: string): void {
  googleAnalytics.event({
    category: 'favorites',
    action,
    nonInteraction: false,
  });
}

interface FavoritesEventData {
  vin?: string;
  // eslint-disable-next-line camelcase
  target_page?: string;
}

function logEventStreamFavoritesAction(
  engagementType: string,
  eventData: FavoritesEventData = {}
): void {
  eventLogger.log({
    event_type: EventType.action,
    engagement_type: engagementType,
    feature: Features.Favorites,
    source_page: SourcePages.Favorites,
    event_context: eventData,
  });
}

export function trackRemoveFavorite(vin: string): void {
  logGAFavoritesInteractionEvent('remove_favorite');
  logEventStreamFavoritesAction('remove_favorite', { vin });
}

export function trackViewFavoriteClick(vin: string, targetPagePath: string): void {
  logGAFavoritesInteractionEvent('view_favorite_click');
  logEventStreamFavoritesAction('view_favorite_click', {
    vin,
    target_page: targetPagePath,
  });
}

export function trackReturnToSeachClick(targetPagePath: string): void {
  logGAFavoritesInteractionEvent('return_to_search_click');
  logEventStreamFavoritesAction('return_to_search_click', { target_page: targetPagePath });
}

export function trackPriceDropTabClick(): void {
  logGAFavoritesInteractionEvent('price_drop_tab_click');
  logEventStreamFavoritesAction('price_drop_tab_click');
}

export function trackFavoritesTabClick(): void {
  logGAFavoritesInteractionEvent('favorites_tab_click');
  logEventStreamFavoritesAction('favorites_tab_click');
}
